import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { usePerformRequest } from "../../lib/usePerformRequest";
import { NonPaginatedResponse } from "../../lib/responses";
import { IAdminProps } from "../../types";
import { Endpoints } from "../../lib/endpoints";
import { AppContext } from "../../lib/context/AppContext";
import { HttpErrorCodesObj, HttpSuccessCodesObj } from "../../lib/data";
import Sidebar from "../../components/Sidebar";

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("t");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const {
    data: profile,
    isLoading: isLoadingProfile,
    reloadData: reloadProfile,
    response: profileResponse,
  } = usePerformRequest<NonPaginatedResponse<IAdminProps>>({
    method: Endpoints.GetProfile().method,
    route: Endpoints.GetProfile().route,
  });

  useEffect(() => {
    if (
      profileResponse &&
      profileResponse.status &&
      profileResponse.status !== HttpSuccessCodesObj.Success
    ) {
      navigate("/login");
    }
  }, [profileResponse]);
  return (
    <AppContext.Provider
      value={{
        profile: profile?.data ?? null,
        reloadProfile,
        isLoadingProfile,
      }}
    >
      <div className="flex min-h-screen bg-black text-white">
        <Sidebar />
        <main className="flex-1 ml-64 p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </AppContext.Provider>
  );
}
